import { useState } from 'react';
import config from '../../common/config';

export default function useConfig() {
  const [appConfig] = useState(config.applicationConfig);

  return appConfig;
}
